const configuredApiBase = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

const normalizeHostname = (hostname) => String(hostname || '').replace(/^www\./i, '').toLowerCase();

export const getApiBase = () => {
  if (!configuredApiBase || typeof window === 'undefined') {
    return configuredApiBase;
  }

  try {
    const configuredUrl = new URL(configuredApiBase);
    const currentUrl = new URL(window.location.origin);

    const isSameProtocol = configuredUrl.protocol === currentUrl.protocol;
    const isSameSite = normalizeHostname(configuredUrl.hostname) === normalizeHostname(currentUrl.hostname);

    if (isSameProtocol && isSameSite) {
      return '';
    }
  } catch (error) {
    return configuredApiBase;
  }

  return configuredApiBase;
};

export const buildApiUrl = (path) => {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${getApiBase()}${normalizedPath}`;
};